import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1279247b")

_pushScopeId("data-v-1279247b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" None ")
const _hoisted_2 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_money = _resolveComponent("money")
  const _component_List = _resolveComponent("List")
  const _component_Button = _resolveComponent("Button")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, { "use-footer": "" }, {
    title: _withId(() => [
      _createVNode(_component_t, {
        path: _ctx.title.label
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title.lableDefault), 1)
        ]),
        _: 1
      }, 8, ["path"])
    ]),
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "line mr-10",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "placeorder_28",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Cancel'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "flex-1 primary",
        onClick: _ctx.confirm
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "placeorder_29",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Submit'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode(_component_t, {
        as: "div",
        path: "placeorder_27",
        class: ["mx-16 option df-cross-center f-medium br-lg", {active: _ctx.choice === 0}],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.choice = 0))
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_List, {
        "list-data": _ctx.options,
        class: "px-16"
      }, {
        default: _withId(({item}) => [
          _createVNode("div", {
            class: [{active: item.pip === _ctx.choice}, "option df-middle t-center br-lg"],
            onClick: ($event: any) => (_ctx.choice = item.pip)
          }, [
            _createVNode(_component_money, {
              class: "flex-1",
              v: item.value
            }, {
              default: _withId(({value}) => [
                _createTextVNode(_toDisplayString(value + ' ' + _ctx.prop('ykUnit', _ctx.product)), 1)
              ]),
              _: 2
            }, 1032, ["v"]),
            _createVNode("div", _hoisted_2, _toDisplayString(item.pip) + " pips", 1)
          ], 10, ["onClick"])
        ]),
        _: 1
      }, 8, ["list-data"])
    ]),
    _: 1
  }))
})